import React from 'react'
import { connect } from 'react-redux'
import DynamicTable from '../../component/DynamicTable'
import geometryActions from '../../action/geometry'
import { localization, secondaryTableOptions, formatTotalElements, getQueryParams } from '../../helper/table'


function GeometriesTable({ dispatch, totalCount }) {

  const fetchPaginatedData = query => dispatch(geometryActions.readPaginated(getQueryParams(query)))

  return (
    <DynamicTable
      columns={[
        { title: "Id", field: "id" },
        { title: "Uid", field: "geometry_id" },
        { title: "Titolo", field: "title" },
        { title: "Nome file", field: "filename" },
        { title: "App", field: "app_title" },
        { title: "Abilitato", field: "is_disabled", render: rowData => !rowData.is_disabled ? 'Si' : 'No' },
        { title: "Extra", field: "extra" },
      ]}
      data={fetchPaginatedData}
      title={formatTotalElements(totalCount)}
      options={secondaryTableOptions}
      localization={localization}
    />
  )
}

const mapStateToProps = store => {
  const { geometry } = store
  return {
    totalCount: geometry.totalCount
  }
}


export default connect(mapStateToProps)(GeometriesTable)